export const getRequestStatus = (state, { key }) => state.editor.requestStatus.status[key] || {};
